import { Alert } from 'antd';

interface MockBannerProps {
  when: string;
  needs?: string;
}

/**
 * Every screen that displays fabricated data mounts this banner. Removing it
 * is a checklist item when the real endpoint lands.
 */
export function MockBanner({ when, needs }: MockBannerProps) {
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 12 }}
      message="Every number and row on this screen is fabricated"
      description={
        <span style={{ fontSize: 12.5 }}>
          Real data lands in <b>{when}</b>
          {needs ? (
            <>
              , when <b>{needs}</b> ships.
            </>
          ) : (
            '.'
          )}{' '}
          The layout and interactions are final; the data underneath is not.
        </span>
      }
    />
  );
}
